/* eslint-env browser */

export const PROFILE_PICTURE_CHANGED_EVENT = 'profilePictureChanged';
export const PROFILE_PICTURE_STORAGE_KEY = 'profilePictureUrl';

export function readProfilePictureUrl() {
  return localStorage.getItem(PROFILE_PICTURE_STORAGE_KEY) || '';
}

export function publishProfilePictureUrl(url) {
  const profilePictureUrl = url || '';

  if (profilePictureUrl) {
    localStorage.setItem(PROFILE_PICTURE_STORAGE_KEY, profilePictureUrl);
  } else {
    localStorage.removeItem(PROFILE_PICTURE_STORAGE_KEY);
  }

  window.dispatchEvent(
    new CustomEvent(PROFILE_PICTURE_CHANGED_EVENT, {
      detail: profilePictureUrl
    })
  );
}
